/*****************************************************************************
 * Open MCT, Copyright (c) 2014-2017, United States Government
 * as represented by the Administrator of the National Aeronautics and Space
 * Administration. All rights reserved.
 *
 * Open MCT is licensed under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0.
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
 * License for the specific language governing permissions and limitations
 * under the License.
 *
 * Open MCT includes source code licensed under additional open source
 * licenses. See the Open Source Licenses file (LICENSES.md) included with
 * this source code distribution or the Licensing information page available
 * at runtime from the About dialog for additional information.
 *****************************************************************************/

define('platform/commonUI/edit/src/actions/RemoveDialog',[], function () {

    /**
     * @callback removeCallback
     * @param {DomainObject} domainObject the domain object to be removed
     */

    /**
     * Construct a new Remove dialog.
     *
     * @param {DialogService} dialogService the service that shows the dialog
     * @param {DomainObject} domainObject the domain object to be removed
     * @param {removeCallback} removeCallback callback that handles removal of the domain object
     * @memberof platform/commonUI/edit
     * @constructor
     */
    function RemoveDialog(dialogService, domainObject, removeCallback) {
        this.dialogService = dialogService;
        this.domainObject = domainObject;
        this.removeCallback = removeCallback;
    }

    /**
     * Display a dialog to confirm the removal of a domain object.
     */
    RemoveDialog.prototype.show = function () {
        var dialog,
            domainObject = this.domainObject,
            removeCallback = this.removeCallback,
            model = {
                title: 'Remove ' + domainObject.getModel().name,
                actionText: 'Warning! This action will permanently remove this object. Are you sure you want to continue?',
                severity: 'alert',
                primaryOption: {
                    label: 'OK',
                    callback: function () {
                        removeCallback(domainObject);
                        dialog.dismiss();
                    }
                },
                options: [
                    {
                        label: 'Cancel',
                        callback: function () {
                            dialog.dismiss();
                        }
                    }
                ]
            };

        dialog = this.dialogService.showBlockingMessage(model);
    };

    return RemoveDialog;
});

